<template>
  <div class="entities-picker">
    <div class="header">
      <div class="header-content">
        <div class="back-btn" @click="$emit('prevStep')">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
      </div>
      <slot name="header-tips"></slot>
    </div>

    <div class="tag-relation-empty" v-if="groupingCase.length === 0">
      <span>该视图分组组暂无有效的关联关系</span>
    </div>

    <el-checkbox-group v-model="curPickFullIds" class="entities-content" v-else>
      <div class="entitie-pick-item" v-for="groupingCaseItem in groupingCase" :key="groupingCaseItem.fullId">
        <el-checkbox :label="groupingCaseItem.fullId">
          <span>{{ groupingCaseItem.fullContent }}</span>
        </el-checkbox>
      </div>
    </el-checkbox-group>

    <div class="bottom-btns">
      <el-button size="mini" @click="$emit('closePopover')">取消</el-button>
      <el-button size="mini" type="primary" :loading="popoverLoading" @click="nextHandle">确认</el-button>
    </div>
  </div>
</template>

<script>
import { groupBy } from 'lodash';
export default {
  data() {
    return {
      curPickFullIds: []
    };
  },
  inject: ['courseUnitGroups'],
  props: {
    popoverLoading: {
      type: Boolean,
      default: false
    },
    caseDetail: {
      type: Object,
      required: true
    },
    currentField: {
      type: Object,
      required: true
    }
  },
  computed: {
    groupingCase() {
      return groupBy(this.caseDetail.groupingCase || [], 'groupRelationId')[this.currentField.groupRelationId] || [];
    }
  },
  methods: {
    nextHandle() {
      if (this.curPickFullIds.length < 1) {
        this.$message.warning('请至少选择一个关联');
        return;
      }

      const curUnitGroup = this.courseUnitGroups.find(o => o.id === this.currentField.groupRelationId);
      const { nerIds = '', labelIds = '' } = curUnitGroup || {};

      const parentLabelId = labelIds.length > 0 ? labelIds.slice(-1)[0] : nerIds.slice(-1)[0];

      if (!parentLabelId) {
        this.$message.warning('标注异常，当前标签对应分组已被删除，请修改标签的关联分组');
        return;
      }

      this.$emit('next', {
        parentLabelId,
        fullIds: this.curPickFullIds
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.entities-picker {
  .header {
    padding: 8px 14px 0px;
    border-bottom: 1px solid #e8ebef;
    margin-bottom: 5px;

    .header-content {
      position: relative;
      left: -4px;
      display: flex;
      align-content: center;
      justify-content: space-between;
      margin-bottom: 2px;

      .back-btn {
        box-sizing: border-box;
        height: 28px;
        line-height: 28px;
        cursor: pointer;
        padding: 0 5px 0 3px;
        color: #3d465a;
        font-size: 14px;
      }
    }
  }

  .tag-relation-empty {
    text-align: center;
    font-size: 12px;
    margin: 20px 0;
  }

  .entities-content {
    box-sizing: border-box;
    padding: 0 14px 5px;
    min-height: 100px;
    max-height: 260px;
    overflow-x: hidden;
    overflow-y: auto;

    .entitie-pick-item {
      display: flex;
      align-items: flex-start;
      margin-top: 10px;

      ::v-deep .el-checkbox {
        width: 100%;
        display: flex;
        align-items: flex-start;

        .el-checkbox__input {
          position: relative;
          top: 3px;
        }

        .el-checkbox__label {
          flex: 1;
          width: 0;
          white-space: normal;
        }
      }

      .entitie-text {
        flex: 1;
        width: 0;
        font-size: 14px;
        line-height: 20px;
        word-break: break-all;
        margin-left: 5px;
      }
    }
  }

  .bottom-btns {
    text-align: right;
    border-top: 1px solid #e8ebef;
    padding: 11px;
  }
}
</style>
